import fragmentPriceRangeFields from './PriceRangeFieldsFragment.gql';

const fragmentConfigurableProductFields = `fragment ConfigurableProductFields on ConfigurableProduct{
  variants{
    product{
        id
        sku
        name
        no_bzt_export
        zuora_completed
        fulfillment_enabled
        tipo_consegna
        taglio_quesiti
        natura
        tipo_abbonamento
        type_id
    }
}
  configurable_options{
    id attribute_id attribute_uid
    attribute_code
    label values { value_index label uid }
  }
  configurable_product_options_selection(configurableOptionValueUids: $configurations) {
    options_available_for_selection {
      attribute_code
      option_value_uids
    }
    media_gallery {
      disabled
      label
      position
      url
    }
  }
}`

export default `
  query getProductsBaseDataForAddToCart(
    $filter: ProductAttributeFilterInput,
    $configurations: [ID!]
  ) {
    products(filter: $filter) {
      items {
        attribute_set_id
        uid
        sku
        no_bzt_export
        zuora_completed
        fulfillment_enabled
        discounted_price_posta
        discounted_price_edicola
        entry_billing_period
        numero_pagine
        dimensione_file
        formato
        name
        stock_status
        only_x_left_in_stock
        taglio_quesiti
        software_module
        software_anagrafiche
        __typename
        price_range {
          ...PriceRangeFields
        }

        ... on CustomizableProductInterface {
          options {
            option_id
            title
            uid
          }
        }
        ... on VirtualProduct{
          promotional_price
          discounted_price
        }
        ... on ConfigurableProduct {
         ... ConfigurableProductFields
        }

        ... on BundleProduct {
          items {
            option_id
            position
            required
            min_options_in_cart
            max_options_in_cart
            sku
            title
            type
            options_type
            uid
            options {
              id
              can_change_quantity
              is_default
              position
              uid
              quantity
              product {
                uid
                sku
                name
                no_bzt_export
                zuora_completed
                fulfillment_enabled
                stock_status
                only_x_left_in_stock
                data_pubblicazione
                special_price
                special_to_date
                special_from_date
                price_range {
                   ...PriceRangeFields
                }
                ... on ConfigurableProduct{
                 ...ConfigurableProductFields
                }
              }
            }
          }
        }

        ... on GroupedProduct {
          items {
            position
            qty
            product {
              uid
              sku
              name
              no_bzt_export
              zuora_completed
              fulfillment_enabled
              stock_status
              only_x_left_in_stock
              price_range {
                ...PriceRangeFields
             }
              thumbnail {
                url
                position
                disabled
                label
              }
            }
          }
        }

      }
    }
  }
  ${fragmentPriceRangeFields}
  ${fragmentConfigurableProductFields}
`;
